import { createFileRoute } from '@tanstack/react-router'
import { GeminiPlayground } from '@/features/admin/gemini-playground'

export const Route = createFileRoute('/_authenticated/admin/gemini-playground')({
  component: GeminiPlayground,
})
